import { cloneDeep } from 'lodash';
import { useState } from 'react';
import type { GoogleCustomerIdsSelection } from './types';

export const GoogleCustomerIdSelector = ({
  googleCustomerIds,
  setGoogleCustomerIds,
}: {
  googleCustomerIds: GoogleCustomerIdsSelection;
  setGoogleCustomerIds: React.Dispatch<
    React.SetStateAction<GoogleCustomerIdsSelection>
  >;
}) => {
  const [search, setSearch] = useState('');

  const selectedGoogleCustomerIds = googleCustomerIds.selection;

  const handleSelect = (item: { id: string; selected: boolean }) => {
    setGoogleCustomerIds((prev) => {
      const out = cloneDeep(prev);

      const updated = out.selection.find((old) => old.id === item.id);
      if (updated) {
        updated.selected = !!!updated?.selected;
      }
      return out;
    });
  };

  const filteredSelectedGoogleCustomerIds = search
    ? selectedGoogleCustomerIds?.filter((item) =>
        item.id.toLowerCase().includes(search.toLowerCase())
      )
    : selectedGoogleCustomerIds;

  return (
    <div>
      <div className="flex items-center justify-between">
        <p className="flex text-black text-opacity-50">Customer Ids:</p>
        <input
          type="text"
          className="w-64 h-6 rounded-lg border-segments-gray"
          placeholder="search"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>
      <div className="mt-4 overflow-y-auto lg:h-44">
        {filteredSelectedGoogleCustomerIds?.map((item) => (
          <div key={item.id} className="">
            <input
              name={item.id}
              id={item.id}
              className="w-4 h-4 mr-2 rounded-sm cursor-pointer focus:ring-0 text-segments-accent-color-1"
              type="checkbox"
              checked={item.selected}
              onChange={() => handleSelect(item)}
              disabled={!!!item.sync_status}
            />
            <label htmlFor={item.id}>
              <span className="text-xs">
                {' '}
                {!!!item.sync_status
                  ? item.id + ' (not available)'
                  : item.id}{' '}
              </span>
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};
